import ButtonCommon from 'components/common/ButtonCommon';
import { OFFER_NAV } from 'constants';
import useLang from 'hooks/useLang';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Promotions from '..';
import { TabWrap } from '../../Offers/ver2/mobile';

const PromotionsMobile = () => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isNavLinkActive = (href) => pathname === href;

  const handleTabOnClick = (path) => {
    navigate(path);
  };

  return (
    <>
      <style>
        {`
          .offers-mobile-offcanvas {
            width: 100%!important;
            height: calc(100% - 70px);
            border: none!important;
          }
          .offers-mobile-offcanvas-backdrop {
            opacity: 0!important;
          }
        `}
      </style>
      <PromotionsStyled>
        <TabWrap>
          {OFFER_NAV.map((tab) => {
            const isActive = isNavLinkActive(tab.href);
            return (
              <ButtonCommon
                key={tab.label}
                value={t(tab.label)}
                background={isActive ? 'var(--c-tab-active-2)' : 'transparent'}
                color={isActive ? 'var(--ds-c-blue)' : '#3f3f3f'}
                styles={{
                  fontSize: '12px',
                  lineHeight: '15px',
                  width: '33.333%',
                  borderRadius: '0px',
                  height: '40px',
                  float: 'left',
                  ...(!isActive && {
                    fontWeight: 500,
                    borderBottom: 'none',
                  }),
                  ...(isActive && {
                    boxShadow: '0px 1px 6px 0px #0000001A',
                    borderBottom: 'none',
                    borderRadius: '100px',
                  }),
                  paddingInline: 0,
                }}
                onClick={() => handleTabOnClick(tab.href)}
              />
            );
          })}
        </TabWrap>
        <ContentBody>
          <Promotions />
        </ContentBody>
      </PromotionsStyled>
    </>
  );
};

const PromotionsStyled = styled.div`
  position: relative;
`;

const ContentBody = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-block: 24px;
  padding-bottom: 120px;
`;
export default PromotionsMobile;
